import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ErrorContent from './ErrorContent'

const Errored = ({
  error,
  syncing,
  onSync,
}: {
  error: string
  syncing: boolean
  onSync: () => void
}) => {
  const errorCode: string = JSON.parse(error).error_code

  const getErrorContent = () => {
    switch (errorCode) {
      case '#DCO02421':
      case '#DCO2423':
      case 'DXLO02413':
        return (
          <ErrorContent
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.employee_code_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.employee_code_message'
            )}
          />
        )
      case '#DCO02401':
      case '#DCO02440':
        return (
          <ErrorContent
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.tax_advisor_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.tax_advisor_message'
            )}
          />
        )
      case '#DCO0204':
      case '#DCO0402':
        return (
          <ErrorContent
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.consultant_client_code_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.consultant_client_code_message'
            )}
          />
        )
      case '#DCO2408':
        return (
          <ErrorContent
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.reference_date_missing_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.reference_date_missing_message'
            )}
          />
        )
      case 'EmploymentPeriod.Overlap':
      case 'EmploymentPeriod.UniqueInMonth':
        return (
          <ErrorContent
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.termination.error.starts_on_mismatch.title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.termination.error.starts_on_mismatch.message'
            )}
          />
        )
      default:
        return (
          <ErrorContent
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.generic_error_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.generic_error_message'
            )}
          />
        )
    }
  }

  return (
    <Box
      background="radicalRed200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
    >
      {getErrorContent()}
      <Button onClick={onSync} disabled={syncing} type="secondary">
        {i18n.t('payroll_integrations.incidences.datev_lauds.hiring.error.retry')}
      </Button>
    </Box>
  )
}

export default Errored
